import {
    Badge,
    Table,
    Text,
} from "@chakra-ui/react";

import DataTable from "../../../components/DataTable";
import EmptyState from "../../../components/EmptyState";

const columns = [
    {
        key: "driver",
        label: "Driver",
    },
    {
        key: "status",
        label: "Status",
    },
    {
        key: "milestone",
        label: "Current Milestone",
    },
    // {
    //     key: "deliveries",
    //     label: "Deliveries",
    // },
    {
        key: "earnings",
        label: "Total Earnings",
        align: "end",
    },
];

const statusColor = {
    Approved: "green",
    Pending: "orange",
    Active: "blue",
    Suspended: "red",
    Rejected: "red",
};

const TopRecruitsTable = ({
    drivers = [],
    milestones = [],
    commissions = [],
    payouts = [],
}) => {
    const data =
        drivers
            .filter(
                driver =>
                    driver.driver
                        ?.driver_id
            )
            .map(
                driver => {
                    const driverId =
                        driver.driver
                            ?.driver_id;

                    const driverMilestones =
                        milestones.filter(
                            milestone =>
                                milestone.driver_id ===
                                driverId
                        );

                    const achievedMilestones =
                        driverMilestones.filter(
                            milestone =>
                                milestone.milestone_status ===
                                "Achieved"
                        );

                    const latestMilestone =
                        achievedMilestones[
                            achievedMilestones.length -
                                1
                        ];

                  const milestoneEarnings =
    achievedMilestones.reduce(
        (
            sum,
            milestone
        ) =>
            sum +
            Number(
                milestone.commission_amount ||
                    0
            ),
        0
    );

const pendingDeliveryEarnings =
    commissions
        .filter(
            commission =>
                commission.driver_id ===
                    driverId &&
                commission.record_type ===
                    "COMMISSION" &&
                commission.commission_status ===
                    "Pending"
        )
        .reduce(
            (
                sum,
                commission
            ) =>
                sum +
                Number(
                    commission.commission_amount ||
                        0
                ),
            0
        );

const paidDeliveryEarnings =
    payouts
        .filter(
            payout =>
                payout.driver_id ===
                    driverId &&
                payout.commission_id &&
                payout.status ===
                    "Paid"
        )
        .reduce(
            (
                sum,
                payout
            ) =>
                sum +
                Number(
                    payout.amount || 0
                ),
            0
        );

const deliveryEarnings =
    pendingDeliveryEarnings +
    paidDeliveryEarnings;

const totalEarnings =
    milestoneEarnings +
    deliveryEarnings;

                    return {
                        id:
                            driverId,

                        driver:
                            [
                                driver.first_name,
                                driver.last_name,
                            ]
                                .filter(
                                    Boolean
                                )
                                .join(
                                    " "
                                ) ||
                            driver.username ||
                            "Unknown Driver",

                        status:
                            driver.driver
                                ?.status ||
                            "Pending",

                        milestone:
                            latestMilestone
                                ?.milestone_type ||
                            "Registration Started",

                        deliveries:
                            latestMilestone
                                ?.required_value ||
                            0,

                        milestoneEarnings,
                        deliveryEarnings,
                        earnings:
                            totalEarnings,
                    };
                }
            )
            .sort(
                (
                    a,
                    b
                ) =>
                    b.earnings -
                    a.earnings
            )
            .slice(
                0,
                5
            );

    return (
        <DataTable
            title="Top Recruits By Earnings"
            total={
                data.length
            }
            data={data}
            columns={columns}
            pageSize={5}
            filters={[]}
            emptyComponent={
               <EmptyState
                imageSize="180px"
                title="No Top Recruits"
                message="Your highest-earning recruited drivers will appear here as they start generating commissions."
            />
            }
            renderRow={(
                recruit
            ) => (
                <Table.Row
                    key={
                        recruit.id
                    }
                >
                    <Table.Cell>
                        <Text
                            fontWeight="600"
                        >
                            {
                                recruit.driver
                            }
                        </Text>
                    </Table.Cell>

                    <Table.Cell>
                        <Badge
                            colorPalette={
                                statusColor[
                                    recruit
                                        .status
                                ] ||
                                "gray"
                            }
                            borderRadius="full"
                            px={3}
                        >
                            {
                                recruit.status
                            }
                        </Badge>
                    </Table.Cell>

                    <Table.Cell>
                        {
                            recruit.milestone
                        }
                    </Table.Cell>

                    {/* <Table.Cell>
                        {
                            recruit.deliveries
                        }
                    </Table.Cell> */}

                  <Table.Cell textAlign="end">
    <Text
        fontWeight="700"
        color="#0F766E"
    >
        P
        {recruit.earnings.toFixed(
            2
        )}
    </Text>

    <Text
        fontSize="xs"
        color="gray.500"
    >
        Milestones: P
        {recruit.milestoneEarnings.toFixed(
            2
        )}
    </Text>

    <Text
        fontSize="xs"
        color="gray.500"
    >
        Deliveries: P
        {recruit.deliveryEarnings.toFixed(
            2
        )}
    </Text>
</Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default TopRecruitsTable;